import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 18c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1zm-1 4h2v-2h-2v2zM4.41 22H18V11c0-1.66 1.34-3 3-3h1V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
}), 'SignalCellularConnectedNoInternet4BarRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellularConnectedNoInternet4BarRounded.js
// module id = 6185
// module chunks = 2